import { PutEffect } from "redux-saga/effects";

export interface GetResponseInterface {
    meta: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: Array<{ [prop: string]: any }>;
}

export const defaultGetResponse = {
    meta: {
        count: 0,
        next: null,
        previous: null
    },
    results: []
};

export interface CustomResponseInterface<T> {
    meta: {
        count: number;
        next: null | string;
        previous: null | string;
    };
    results: T;
}

export type GeneratorYieldType<T> = PutEffect<{
    payload: T;
    type: string;
}>;
